import localforage from 'localforage'
import Bouteille from './Bouteille'
import Fibsdd from './Fibsdd'
import Installation from './Installation'
import Offline from './Offline'
import Api from '../core/Api'

class OperationBouteille {

    isAdmin() {
        return new Promise((resolve) => {

            localforage
                .getItem('profil')
                .then(res => {

                    let profil = JSON.parse(res);

                    resolve(profil.admin);

                })

        })
    }

    // PROCESS D'AJOUT OPERATION BOUTEILLE
    newManipFluide(idFibsdd, callback) {
        let fi = new Fibsdd;

        fi.getFibsdd(idFibsdd).then(fibsdd => {

            Installation.getInstallation(fibsdd.installation).then(install => {

                window.results = [];

                this
                    .askTypeOperation(fibsdd, install)
                    .then(typeOp => this.getBouteillesForOperation(typeOp))
                    .then(bouteilles => this.choiceBouteille(bouteilles))
                    .then(bouteille => this.choiceQuantity(bouteille))
                    .then(quantite => this.createOperation(quantite))
                    .then(op => this.addOfflineOperation(op))
                    .then(op => {

                        Bouteille
                            .applyOperation(op)
                            .then(() => callback(op))
                            .catch()

                    })
                    .catch()

            })

        })

    }

    // DEBUT REC OPERATION
    askTypeOperation(fibsdd, install) {

        results['fibsdd'] = fibsdd;
        results['installation'] = install;

        return new Promise((resolve, reject) => {

            const choices = {
                1: 'Ajout fluide vierge',
                2: 'Ajout fluide recyclé',
                3: 'Ajout fluide régénéré',
                4: 'Retrait fluide pour traitement',
                5: 'Retrait fluide pour réutilisation',
            };

            const choicesMeta = [
                { id: 1, label: 'Ajout fluide vierge',              group: 'Ajout'   },
                { id: 2, label: 'Ajout fluide recyclé',              group: 'Ajout'   },
                { id: 3, label: 'Ajout fluide régénéré',             group: 'Ajout'   },
                { id: 4, label: 'Retrait fluide pour traitement',    group: 'Retrait' },
                { id: 5, label: 'Retrait fluide pour réutilisation', group: 'Retrait' },
            ];

            let opHtml = '<style>.so-group{font-size:1.1rem;font-weight:700;text-transform:uppercase;color:#aaa;margin:10px 0 4px;letter-spacing:.05em}.so-list{border:2px solid #d0d0d0;border-radius:6px;padding:6px;margin-bottom:6px}.so-item{display:flex;align-items:center;gap:12px;padding:10px 12px;border-radius:6px;cursor:pointer;border:2px solid transparent;margin-bottom:4px;background:#f9f9f9;transition:border-color .15s,background .15s}.so-item:last-child{margin-bottom:0}.so-item:hover{background:#eef4fb;border-color:#5698d2}.so-item.selected{background:#e0edf8;border-color:#5698d2}.so-label{font-size:1.4rem;font-weight:600;color:#333}</style>';
            opHtml += '<div class="so-group">Ajout</div><div class="so-list">';
            choicesMeta.filter(c => c.group === 'Ajout').forEach(c => {
                opHtml += '<div class="so-item" data-id="' + c.id + '" onclick="document.querySelectorAll(\'.so-item\').forEach(function(i){i.classList.remove(\'selected\')});this.classList.add(\'selected\');document.getElementById(\'so-val\').value=this.dataset.id">'
                    + '<span class="so-label">' + c.label + '</span>'
                    + '</div>';
            });
            opHtml += '</div><div class="so-group">Retrait</div><div class="so-list">';
            choicesMeta.filter(c => c.group === 'Retrait').forEach(c => {
                opHtml += '<div class="so-item" data-id="' + c.id + '" onclick="document.querySelectorAll(\'.so-item\').forEach(function(i){i.classList.remove(\'selected\')});this.classList.add(\'selected\');document.getElementById(\'so-val\').value=this.dataset.id">'
                    + '<span class="so-label">' + c.label + '</span>'
                    + '</div>';
            });
            opHtml += '</div><input type="hidden" id="so-val" value="">';

            swal({
                title: "Type d'opération",
                html: opHtml,
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                preConfirm: () => {
                    return new Promise((resolve, reject) => {
                        const val = document.getElementById('so-val').value;
                        if (!val) {
                            reject('Sélectionnez une option');
                        } else {
                            resolve(val);
                        }
                    });
                }
            }).then(result => {

                let typeSearched = [];
                let idFluideSearched = null;
                let searchRegen = false;

                let resultStr = choices[result];

                if (resultStr.includes('Ajout')) {

                    if (resultStr.includes('vierge')) {
                        typeSearched = ['Fluide frigorigène']
                    } else if (resultStr.includes('recyclé')) {
                        typeSearched = ['Récupération', 'Transfert']
                    } else if (resultStr.includes('régénéré')) {
                        typeSearched = ['Fluide frigorigène'];
                        searchRegen = true;
                    }

                    if (fibsdd.natures.retrofit && fibsdd.natures.newFluide) {
                        idFluideSearched = parseInt(fibsdd.natures.newFluide)
                    } else {
                        idFluideSearched = install.fluide ? install.fluide.id : null
                    }

                } else {

                    typeSearched = ['Récupération', 'Transfert'];
                    idFluideSearched = install.fluide ? install.fluide.id : null

                }

                if (idFluideSearched === null) {
                    swal({
                        title: 'Opération impossible',
                        text: "Aucun fluide n'est associé à cette installation.",
                        type: 'error'
                    });
                    reject('Fluide manquant sur l\'installation');
                    return;
                }

                resolve({
                    'realType': resultStr,
                    'idType': result,
                    'types': typeSearched,
                    'idFluide': idFluideSearched,
                    'searchRegen' : searchRegen
                })

            })

        })

    }

    // RENVOIE LES BOUTEILLES CORRESPONDANTE AU CHOIX PRÉCÉDENT
    async getBouteillesForOperation(typeOp) {
        results['typeOp'] = typeOp;

        const list = await Bouteille.getList();
        const fluids = JSON.parse(await localforage.getItem('listFluides')).noFiltre;

        const filtered = list.filter(b => {
            const gotFluide = b.poids_net !== 0;
            const notFull = b.poids_net !== b.poids_max;
            const typeBoutOk = typeOp.types.includes(b.type);

            let fluideOk = false;

            if (typeOp.searchRegen) {
                if (b.fluide !== null) {
                    const fluid = fluids.find(f => f.id === typeOp.idFluide);
                    const regenFluid = fluids.find(f => f.nom === `${fluid.nom} R`);
                    fluideOk = regenFluid && regenFluid.id === b.fluide.id;
                }
            } else {
                fluideOk = b.hasOwnProperty('fluide') && b.fluide !== null && b.fluide.id === typeOp.idFluide;
            }

            let noTypeFluide = ( (!_.has(b, 'fluide') || b.fluide === null ) && b.type !== 'Fluide frigorigène');
            const boutActive = b.actif === true;

            if (boutActive && typeBoutOk) {
                if (typeOp.realType.includes('Ajout') && fluideOk && gotFluide) {
                    return true;
                } else if (typeOp.realType.includes('Retrait') && (fluideOk || noTypeFluide) && notFull) {
                    return true;
                }
            }
        });

        results['bouteilles'] = filtered;

        const allOps = await this.getList();
        const boutToDel = [];

        for (const bout of filtered) {
            const boutId = String(bout.id).includes('N-') ? bout.id : parseInt(bout.id);
            const ops = allOps.filter(op => {
                if (op.bouteille && op.bouteille.id === boutId) return true;
                return op.id_bouteille === boutId;
            });
            const err = [];

            if (typeOp.realType.includes('recyclé') || typeOp.realType.includes('réutilisation')) {
                for (const op of ops) {
                    if (op.id_type == 4) {
                        err.push(op.id);
                    }
                }
            } else if (typeOp.realType.includes('traitement')) {
                let balance = 0;
                for (const op of ops) {
                    if(op.id_type == 5) {
                        balance = round(balance + op.quantite, 3);
                    }else if(op.id_type == 2) {
                        balance = round(balance - op.quantite, 3);
                    }
                }
                if (balance !== 0) {
                    err.push('balance pas OK !!');
                }
            }

            if (err.length !== 0) {
                boutToDel.push(bout.id);
            }
        }

        return filtered.filter(bout => !boutToDel.includes(bout.id));
    }

    // RETOURNE LA BOUTEILLE SÉLECTIONNÉE
    choiceBouteille(bouteilles) {

        return new Promise((resolve, reject) => {


            if (bouteilles.length === 0) {

                swal({
                    title: 'Aucune bouteille',
                    text: "Vous n'avez aucune bouteille active pouvant répondre à ce type d'opération sur cette installation",
                    type: 'error',
                    confirmButtonText: 'Ajouter bouteille'
                }).then(function () {

                    Bouteille.askAddBouteille()

                })

            } else {

                let isAdmin = false;
                let op = new OperationBouteille();

                op.isAdmin().then((res) => {
                    isAdmin = res;

                    let headerHtml = '';
                    if (isAdmin) {
                        headerHtml += '<a style="display:block;width:184px;margin:0 auto 10px;padding:10px;background:#5698d2;color:white;text-align:center;line-height:30px;border-radius:4px;text-decoration:none;font-weight:600;" onclick="swal.closeModal()" href="#/new-bouteille">Ajouter bouteille</a>';
                    }
                    headerHtml += '<a style="display:block;width:184px;margin:0 auto 15px;padding:10px;background:#5698d2;color:white;text-align:center;line-height:30px;border-radius:4px;text-decoration:none;font-weight:600;" onclick="swal.closeModal()" href="fi360://scan?success=scanForOp">SCAN OTAG</a>';

                    let listHtml = '<style>.sb-list{max-height:260px;overflow-y:auto;margin-top:10px;text-align:left;border:2px solid #d0d0d0;border-radius:6px;padding:6px}.sb-item{padding:10px 12px;border-radius:6px;cursor:pointer;border:2px solid #e0e0e0;margin-bottom:6px;background:#f9f9f9;transition:border-color .15s,background .15s}.sb-item:hover{background:#eef4fb;border-color:#5698d2}.sb-item.selected{background:#e0edf8;border-color:#5698d2}.sb-code{font-size:1.5rem;font-weight:700;color:#333}.sb-otag{font-weight:700;color:#5698d2}.sb-sub{font-size:1.2rem;color:#888;margin-top:2px}</style>';
                    listHtml += '<div class="sb-list">';

                    for (let b of bouteilles) {
                        const fluide = (b.hasOwnProperty('fluide') && b.fluide !== null) ? b.fluide.nom : 'Indéfini';
                        const otagHtml = b.otag ? '<span class="sb-otag"> [' + b.otag + ']</span>' : '';
                        listHtml += '<div class="sb-item" data-id="' + b.id + '" onclick="document.querySelectorAll(\'.sb-item\').forEach(function(i){i.classList.remove(\'selected\')});this.classList.add(\'selected\');document.getElementById(\'sb-val\').value=this.dataset.id">'
                            + '<div class="sb-code">' + b.code + otagHtml + '</div>'
                            + '<div class="sb-sub">' + fluide + ' &mdash; ' + b.poids_net + '/' + b.poids_max + ' Kg</div>'
                            + '</div>';
                    }

                    listHtml += '</div><input type="hidden" id="sb-val" value="">';

                    swal({
                        title: 'Sélectionnez une bouteille',
                        html: headerHtml + listHtml,
                        showCancelButton: true,
                        cancelButtonText: 'Annuler',
                        preConfirm: () => {
                            return new Promise((resolve, reject) => {
                                const val = document.getElementById('sb-val').value;
                                if (!val) {
                                    reject('Vous devez choisir une bouteille !');
                                } else {
                                    resolve(val);
                                }
                            });
                        }
                    }).then(function (value) {

                        if (!_.includes(value, 'N-')) {
                            value = parseInt(value)
                        }

                        resolve(_.find(bouteilles, ['id', value]))

                    }).catch(err => reject(err))

                });

            }
        })
    }

    // RETOURNE LA QUANTITÉ MANIPULÉE
    choiceQuantity(bouteille) {
        results['bouteille'] = bouteille;

        let messageSmall = '';

        if(bouteille.fluide) {
            messageSmall = bouteille.poids_net + '/' + bouteille.poids_max + 'Kg (' + bouteille.fluide.nom + ')';
        } else {
            messageSmall = bouteille.poids_net + '/' + bouteille.poids_max + 'Kg';
        }

        return new Promise((resolve) => {
            swal({
                title: 'Quantité manipulée',
                html: '<input type="number" step="0.001" required id="manipulation" class="input"><br><small> ' + messageSmall + ' </small>',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                preConfirm: function () {
                    return new Promise(function (resolve, reject) {
                        let input = document.getElementById('manipulation').value;
                        let precision;

                        if (input.indexOf(',') !== -1) {
                            precision = input.split(',')[1].length
                        } else if (input.indexOf('.') !== -1) {
                            precision = input.split('.')[1].length
                        } else {
                            precision = 0;
                        }

                        if (precision > 3) {

                            reject('Veuillez saisir 3 chiffres après la virgule au max')

                        } else {


                            let quantite = round(document.getElementById('manipulation').value, 3);
                            let actuel = round(bouteille.poids_net, 3);
                            let max = round(bouteille.poids_max, 3);
                            let libre = round(max - actuel, 3);

                            if (quantite > 0) {

                                if (results.typeOp.realType.includes('Ajout') && quantite <= actuel) {

                                    results.quantite = quantite;
                                    resolve(quantite);

                                } else if (results.typeOp.realType.includes('Retrait') && quantite <= libre) {

                                    /* OLD SYSTEM

                                      if (actuel === 0) {

                                          if (results.typeOp.realType.includes('traitement')) {



                                              let opObject = new OperationBouteille();
                                              opObject
                                                  .askClotureAndAnnexe()
                                                  .then(() => {

                                                      results.quantite = quantite;
                                                      resolve(quantite);

                                                  })
                                                  .catch(err => reject(err))

                                              } else {

                                                  results.quantite = quantite;
                                                  resolve(quantite);

                                              }


                                      } else {

                                          results.quantite = quantite;
                                          resolve(quantite);

                                      } */

                                    results.quantite = quantite;
                                    resolve(quantite);

                                } else {
                                    reject('Quantité incohérente ( ' + actuel + ' / ' + max + ' Kg )')
                                }

                            } else {
                                reject('Veuillez saisir une quantité positive')
                            }

                        }

                    })
                }

            }).then(function (quantite) {

                resolve(quantite);

            })

        })

    }

    askClotureAndAnnexe() {
        return new Promise((resolve, reject) => {

            let bouteille = results['bouteille'];

            swal({
                title: 'Bouteille dédiée',
                text: 'Cette bouteille est elle utilisée uniquement pour cette intervention ?',
                type: 'question',
                showCancelButton: true,
                confirmButtonText: 'Oui',
                cancelButtonText: 'Non',
            }).then(
                () => {
                    swal({
                        title: 'Confirmation nécessaire',
                        text: "Cette opération clôturera la bouteille, elle ne sera plus utilisable.",
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Confirmer',
                        cancelButtonText: 'Annuler',
                    }).then(
                        () => {
                            Bouteille
                                .clotureBouteille(bouteille.id)
                                .then(() => {
                                    swal(
                                        'Bouteille clôturée',
                                        "Vous ne pouvez plus effectuer d'opération sur cette bouteille",
                                        'success'
                                    ).then(() => resolve(true), () => resolve(true))
                                })
                                .catch(err => reject(err));
                        },
                        () => {
                            this.askRenameAnnexe(bouteille).then(res => resolve(res))
                        }
                    );
                },
                () => {
                    this.askRenameAnnexe(bouteille).then(res => resolve(res))
                }
            )
        })
    }

    askRenameAnnexe(bouteille) {
        return new Promise(resolve => {
            swal({
                title: 'Renommez votre annexe 1 si besoin',
                input: 'text',
                inputValue: 'AN-' + bouteille.code,
                allowOutsideClick: false,
                preConfirm: (annexe) => {
                    return new Promise((resolve, reject) => {
                        if (annexe.trim() !== '') {
                            Bouteille
                                .setNumeroAnnexe(bouteille.id, annexe)
                                .then(res => resolve(res))
                                .catch(err => reject(err))
                        } else {
                            reject("Le numéro d'annexe ne doit pas être vide")
                        }
                    })
                }
            }).then(() => {
                swal({
                    type: 'success',
                    title: 'Opération validée',
                    html: "Numéro d'annexe enregistré",
                    allowOutsideClick: false
                }).then(() => resolve(true))
            })
        });
    }

    // ENREGISTRE ET RETOURNE L'OPERATION
    createOperation(quantite) {
        return new Promise((resolve) => {

            localforage
                .getItem('profil')
                .then(res => {

                    let profil = JSON.parse(res);

                    let op = {
                        id: 'N-' + +new Date(),
                        id_fibsdd: results.fibsdd.id,
                        id_bouteille: results.bouteille.id,
                        type: results.typeOp.realType,
                        id_type: results.typeOp.idType,
                        quantite: round(quantite, 3),
                        id_fluide: results.typeOp.idFluide,
                        date: moment().format('YYYY-MM-DD'),
                        user: profil.first_name.charAt(0).toUpperCase() + '. ' + profil.last_name.toUpperCase(),
                        commentaire: null,
                        createdAt:  moment().format('YYYY-MM-DD HH:mm:ss')
                    };

                    if(parseInt(results.typeOp.idType) === 5) {
                        swal({
                            title: 'Information',
                            text: 'Si vous avez réintroduit le fluide recyclé récupéré, vous devez faire "Ajout de fluide recyclé" dans les manipulations pour vider la bouteille',
                            type: 'question',
                            showCancelButton: true,
                            cancelButtonText: 'OK',
                            showConfirmButton: false
                        })
                    }


                    resolve(op);

                })

        })

    }

    addOfflineOperation(op) {
        return new Promise((resolve, reject) => {

            let opObj = new OperationBouteille();

            opObj.getList().then(data => {
                data.push(op);
                localforage
                    .setItem('listOperations', JSON.stringify(data))
                    .then(() => {

                        Offline.saveAction({
                            action: 'add',
                            type: 'OperationBouteille',
                            id: op.id
                        });

                        resolve(op)

                    })
                    .catch(err => reject(err))
            })

        })
    }

    removeOnlineOperation(id) {

        return new Promise((resolve, reject) => {

            Api
                .init()
                .then(api => {

                    api
                        .delete('/operation/' + id)
                        .then(() => {

                            Offline
                                .deleteAction(id, 'OperationBouteille')
                                .then(() => resolve(true))
                                .catch(err => reject(err))

                        })
                        .catch(err => {
                            if(err.response.status === 403 || err.response.status === 404){
                                resolve(true)
                            } else {
                                reject(err)
                            }
                        })
                })
                .catch(err => reject(err))

        })

    }

    addOnlineOperation(op) {

        return new Promise((resolve, reject) => {

            //TEMPO
            let idBouteille = op.id_bouteille;
            let oldId = op.id;
            let opToSend = {};
            opToSend.fluide = op.id_fluide;
            opToSend.type = parseInt(op.id_type);
            opToSend.fibsdd = op.id_fibsdd;
            opToSend.quantite = op.quantite;
            opToSend.commentaire = op.commentaire ? op.commentaire : null;
            opToSend.createdAt = op.createdAt;


            //resolve(true)

            // DEFINITIF
            Api
                .init()
                .then(api => {
                    api
                        .post('/operation/' + idBouteille, opToSend)
                        .then(res => {

                            if (!res.data.errors) {

                                let opObject = new OperationBouteille();
                                opObject.getList().then(list => {

                                    let newList = list.map(operation => {
                                        if (operation.id === oldId) {
                                            operation.id = res.data.id
                                        }
                                        return operation
                                    });

                                    localforage
                                        .setItem('listOperations', JSON.stringify(newList))
                                        .then(() => Offline.deleteAction(oldId, 'OperationBouteille'))
                                        .then(() => resolve(true))
                                        .catch(err => reject(err))

                                })

                            } else {
                                reject(res.data.errors)
                            }
                        })
                        .catch(err => {
                            reject(err)
                        })
                })
                .catch(err => reject(err))

        })


    }

    cancelOperation(id) {
        let that = this;
        return new Promise((resolve, reject) => {

            this
                .getOperation(id)
                .then(Bouteille.rollbackOperation)
                .then(res => {

                    let opObj = new OperationBouteille();
                    opObj
                        .removeOperation(res)
                        .then(() => resolve(id))
                        .catch(err => reject(err))

                })
                .catch(e => console.log(e))
        })

    }

    removeOperation(id) {
        return new Promise((resolve, reject) => {

            this.getList().then(data => {

                let indexToDel = _.findIndex(data, ['id', id]);
                data.splice(indexToDel, 1);

                localforage
                    .setItem('listOperations', JSON.stringify(data))
                    .then(() => {

                        if (!_.includes(id, 'N-')) {

                            id = parseInt(id);

                            Offline
                                .deleteAction(id, 'OperationBouteille')
                                .then(() => {
                                    return Offline.saveAction({
                                        id: id,
                                        type: 'OperationBouteille',
                                        action: 'delete'
                                    })
                                })
                                .then(() => {resolve(true)})
                                .catch(err => reject(err))

                        } else {
                            Offline
                                .deleteAction(id, 'OperationBouteille')
                                .then(res => resolve(res))
                                .catch(err => reject(err))
                        }

                    })
                    .catch(err => reject(err))

            })


        })

    }

    async getOpsForBouteille(id, displayName = true) {

        if (!String(id).includes('N-')) {
            id = parseInt(id);
        }

        const list = await this.getList();

        const ops = list.filter(op => {
            if (op.bouteille && op.bouteille.id === id) return true;
            return op.id_bouteille === id;
        });

        if (displayName === true) {
            const usrs = await localforage.getItem('listUsers');
            const lstUsrs = JSON.parse(usrs);
            if (lstUsrs) {
                for (const op of ops) {
                    const user = lstUsrs.find(u => u.id === op.user);
                    if (user) op.user = user.nom;
                }
            }
        }

        return ops;

    }

    getOpsForFibsdd(id) {

        return new Promise((resolve, reject) => {

            this
                .getList()
                .then(data => {
                    let ops = data.filter(op => op.id_fibsdd == id);
                    resolve(ops)

                })
                .catch(err => reject(err))

        })

    }

    getOperation(id) {
        return new Promise((resolve) => {
            this.getList().then(data => {
                if (!_.includes(id, 'N-')) {
                    id = parseInt(id)
                }

                let op = _.find(data, ['id', id]);
                if (op) {
                    resolve(op)
                }
            })
        })
    }

    getList() {
        return new Promise((resolve, reject) => {
            localforage
                .getItem('listOperations')
                .then(data => resolve(JSON.parse(data)))
                .catch(error => reject(error))
        })
    }
}

export default OperationBouteille



// WEBPACK FOOTER //
// ./src/js/models/OperationBouteille.js